import { Controller } from "stimulus";

export default class FilterGreyOut extends Controller<HTMLFormElement> {
	connect() {
		this.updateCheckboxes(false);
	}

	getActiveSlugs() {
		return Array.from(
			document.querySelectorAll(`input[type=checkbox][name=filters]:checked`)
		).map((e: HTMLInputElement) => e.value);
	}

	getForm() {
		if (this.element.nodeName.toLowerCase() == "form") {
			return this.element;
		} else {
			return this.element.querySelector("form");
		}
	}

	async updateCheckboxes(submit = true) {
		const response = await fetch(`/api/per-filter-counts/`, {
			method: "post",
			body: JSON.stringify({
				active_slugs: this.getActiveSlugs(),
			}),
			headers: {
				"content-type": "application/json",
			},
		});
		const data = (await response.json()) as Record<string, number | undefined>;
		Object.entries(data).forEach(([id, count]) => {
			this.element
				.querySelectorAll(`input[data-count-id="${id}"]`)
				.forEach((e: HTMLInputElement) => {
					const always_clickable =
						e.getAttribute("data-always-clickable") != null;
					if (count == 0 && !always_clickable) {
						e.setAttribute("disabled", "");
					} else {
						e.removeAttribute("disabled");
					}
				});
		});
		if (submit && this.getForm().getAttribute("data-auto-submit") != "false") {
			this.getForm()?.requestSubmit();
		}
	}
}
